/* eslint-disable no-nested-ternary */
import { Box, CircularProgress, useTheme } from '@mui/material'
import React, { MutableRefObject, useCallback, useEffect, useRef } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import styled from 'styled-components'

import {
    FocusableComponentLayout,
    FocusContext,
    FocusDetails,
    useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import { EpisodeItemInterface } from '@/types/vod/VodItemDetails'
import { getUseVodItemsDetails } from '@/shared/getContainer/getUseVodItemsDetails'
import { SeriesEpisodeSliderItem } from '@/features/VOD/components/SeriesEpisodeSliderItem'
import { useEpisodesSliderHook } from '@/features/VOD/hooks/useEpisodesSliderHook'

const VodRowViewScrollingWrapper = styled.div`
    overflow-x: hidden;
    display: flex;
    overflow-y: hidden;
    flex-shrink: 1;
    flex-grow: 1;
`
const VodRowViewScrollingContent = styled.div`
    display: flex;
    flex-direction: row;
`

const useItemDetails = await getUseVodItemsDetails()

interface IEpisodeSlider {
    episodes: EpisodeItemInterface[] | undefined
    episodeId: string
    actualSeasonId: string
    getItemDetails?: (
        item: {
            productId: string | null
            assetType: string | undefined
            id: string
        },
        value?: boolean | undefined
    ) => void
    onFocusProp?: (
        layout: FocusableComponentLayout,
        props: object,
        details: FocusDetails
    ) => void
}

// const ConfigRepository = await getConfigRepository()
// const configRepository = ConfigRepository.Instance

export const EpisodeSliderTV = ({
    episodes,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    episodeId,
    actualSeasonId,
}: IEpisodeSlider) => {
    const theme = useTheme()
    // const [isModalOpen, setIsModalOpen] = useState(false)

    const animationRef = useRef<number | null>(null)
    const scrollTargetRef = useRef(0)
    const scrollStartRef = useRef(0)
    const scrollStartTimeRef = useRef<number | null>(null)

    const { ref, focusKey } = useFocusable()

    const scrollingRef: MutableRefObject<HTMLDivElement | null> = useRef(null)

    const customScrollTo = (targetPosition: number, duration: number) => {
        if (!scrollingRef.current) return

        scrollStartRef.current = scrollingRef.current.scrollLeft
        scrollTargetRef.current = targetPosition
        scrollStartTimeRef.current = null

        if (animationRef.current) return

        const animationStep = (currentTime: number) => {
            if (!scrollingRef.current) return
            if (scrollStartTimeRef.current === null)
                scrollStartTimeRef.current = currentTime

            const distance = scrollTargetRef.current - scrollStartRef.current
            const timeElapsed = currentTime - scrollStartTimeRef.current
            const progress = Math.min(timeElapsed / duration, 1) // Cap progress at 1

            // Ease-in-out function for smooth scrolling effect
            const easeInOutQuad = (t: number): number =>
                t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

            const newScrollPosition =
                scrollStartRef.current + distance * easeInOutQuad(progress)
            scrollingRef.current.scrollLeft = newScrollPosition

            if (timeElapsed < duration) {
                animationRef.current = requestAnimationFrame(animationStep)
            } else {
                scrollingRef.current.scrollLeft = scrollTargetRef.current
                animationRef.current = null
            }
        }
        animationRef.current = requestAnimationFrame(animationStep)
    }

    const onAssetFocus = useCallback(
        ({ x }: { x: number }) => {
            customScrollTo(x, 500)
        },
        [scrollingRef]
    )

    const { getItemDetails } = useItemDetails()

    // const {
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     pin,
    //     setPin,
    //     isPinValid,
    //     setIsPinValid,
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     isPinError,
    //     setIsPinError,
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     shouldCheckPin,
    //     setShouldCheckPin,
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     handleCheckPin,
    // } = usePinVerification()

    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        selectedEpisode,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setSelectedEpisode,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchMoreEpisodes,
        handleItemClick,
        setEpisodeList,
        episodeList,
    } = useEpisodesSliderHook({ getItemDetails, episodes, actualSeasonId })
    //
    // const handleOpenModal = () => {
    //     setIsModalOpen((prev) => !prev)
    //     setShouldCheckPin((prev) => ({ ...prev, shouldCheck: true }))
    //     isModalOpen &&
    //         isPinValid &&
    //         selectedEpisode &&
    //         getItemDetails?.({
    //             productId: selectedEpisode.productId,
    //             assetType: selectedEpisode.productType,
    //             id: selectedEpisode.productId,
    //         })
    // }
    //
    // const handleChangePin = (value: string) => {
    //     setPin(value)
    //     setIsPinError('')
    // }
    //
    // const handleCancelPin = () => {
    //     setShouldCheckPin({
    //         shouldCheck: false,
    //         id: '-1',
    //     })
    //     setPin('')
    //     setIsPinError('')
    //     setIsPinValid(false)
    //     setIsModalOpen(false)
    // }
    //
    // const handleBuyEpisode = (episode: EpisodeItemInterface) => {
    //     setIsModalOpen(true)
    //     setShouldCheckPin((prev) => ({
    //         ...prev,
    //         shouldCheck: true,
    //     }))
    //     setSelectedEpisode(episode)
    // }
    //
    // const handleMouseEnter = (item: EpisodeItemInterface) => {
    //     getItemDetails({
    //         productId: item.productId,
    //         assetType: item.productType,
    //         id: `vod:${item.productId}` || '',
    //         serviceName: item.serviceName || '',
    //     })
    // }

    useEffect(
        () => () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current)
        },
        []
    )

    useEffect(() => {
        if (!episodes) return
        setEpisodeList(episodes)
    }, [episodes])

    const rowViewContainerStyle = {
        marginBottom: '40px',
        position: 'relative',
        width: '99%',
        mt: '50px',
    }

    const progressBarWrapper = {
        position: 'absolute',
        bottom: '20px',
        left: '15%',
        width: '70%',
    }

    const notPurchased = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'custom.black',
        opacity: 0.5,
    }

    const buyButtonStyle = {
        transition: 'all 0.2s ease-out',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px 12px',
        gap: '8px',
        position: 'absolute',
        width: '112px',
        minWidth: '36px',
        height: '36px',
        minHeight: '36px',
        left: 'calc(50% - 112px/2)',
        top: 'calc(50% - 36px/2)',
        background: theme.palette.primary.main,
        borderRadius: '10px',
        color: 'custom.black',
        fontSize: '13px',
        '&:hover': {
            background: theme.palette.primary.main,
        },
    }

    const messageStyle = {
        position: 'absolute',
        left: '50% !important',
        top: ' 50% !important',
        transform: 'translate(-50%, -50%)',
    }

    return (
        <FocusContext.Provider value={focusKey}>
            <Box ref={ref} sx={rowViewContainerStyle}>
                <VodRowViewScrollingWrapper ref={scrollingRef}>
                    <VodRowViewScrollingContent>
                        {episodeList.length ? (
                            <>
                                {episodeList.map(
                                    (episode: EpisodeItemInterface) => (
                                        <SeriesEpisodeSliderItem
                                            key={episode.productId}
                                            episode={episode}
                                            handleBuyEpisode={handleItemClick}
                                            progressBarWrapper={
                                                progressBarWrapper
                                            }
                                            notPurchased={notPurchased}
                                            buyButtonStyle={buyButtonStyle}
                                            onFocusProp={onAssetFocus}
                                        />
                                    )
                                )}
                            </>
                        ) : (
                            <Box sx={messageStyle}>
                                <CircularProgress color="inherit" />
                            </Box>
                        )}
                    </VodRowViewScrollingContent>
                </VodRowViewScrollingWrapper>
            </Box>
        </FocusContext.Provider>
    )
}
